<template>
  <main class="dashboard edit-profile">
    <div class="container-fluid container-fluid--max">
      <div class="card">
        <div class="card-body">
          <router-link :to="{ name: 'clientDashboard' }" tag="a" class="back btn btn-link uppercase smaller pl-0">
            <i class="back__icon fa fa-close mr-h" aria-hidden="true"></i>Retour
          </router-link>
          <section class="dash-edit-profile px-lg-5 mt-4 row">
            <h1 class="dashboard__title heading-secondary col-12">Éditer les informations de mon profil</h1>
            <vv-observer v-slot="{ invalid }" tag="form" class="col-lg-10 mt-4 mx-auto" @submit.prevent="submit">
              <div class="form-row">
                <r-input v-model="params.last_name" label="Nom" icon="user" class="col-sm" :error="errors.last_name" />
                <r-input v-model="params.first_name" label="Prénom" icon="user-o" class="col-sm" :error="errors.first_name" />
              </div>
              <r-input v-model="params.email" label="Email" type="email" icon="envelope-o" :error="errors.email" />
              <r-input v-model="params.address" label="Adresse" icon="address-card-o" :error="errors.address" />
              <div class="form-row">
                <zc-input v-model="params.zip_code" class="col-sm-4" :error="errors.zip_code" />
                <r-input v-model="params.city" label="Ville" icon="map-o" class="col-sm-8" :error="errors.city" />
              </div>
              <div class="form-row">
                <p-input v-model="params.phone" class="col-sm" />
                <r-input
                  v-model="params.current_password"
                  label="Ancien mot de passe"
                  :type="currentPassword"
                  icon="key"
                  class="col-sm"
                  :required="false"
                  :error="errors.current_password">
                  <i class="has-icon-right__icon fa fa-eye" @click.prevent="switchType('currentPassword')"></i>
                </r-input>
              </div>
              <div class="form-row">
                <r-input
                  v-model="params.password"
                  label="Nouveau mot de passe"
                  :type="password"
                  icon="key"
                  class="col-sm"
                  :required="false"
                  :rules="'min:8'"
                  :error="errors.password">
                  <i class="has-icon-right__icon fa fa-eye" @click.prevent="switchType('password')"></i>
                </r-input>
                <r-input
                  v-model="params.password_confirmation"
                  label="Confirmer le nouveau mot de passe"
                  :type="passwordConfirmation"
                  icon="key"
                  class="col-sm"
                  :required="false"
                  :rules="'min:8'"
                  :error="errors.password_confirmation">
                  <i class="has-icon-right__icon fa fa-eye" @click.prevent="switchType('passwordConfirmation')"></i>
                </r-input>
              </div>
              <div class="d-flex justify-content-center my-3">
                <s-button :loading="loading" @submit="submit" :css-class="'access-form__btn px-5 btn-' + $mainColor" :disabled="invalid">
                  Enregistrer
                </s-button>
              </div>
            </vv-observer>
          </section>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'EditProfile',
  data () {
    return {
      loading: false,
      params: {},
      currentPassword: 'password',
      password: 'password',
      passwordConfirmation: 'password',
      errors: {}
    }
  },
  computed: {
    ...mapState(['currentClient', 'clientAuth'])
  },
  mounted () {
    this.params = _.clone(this.currentClient)
  },
  methods: {
    switchType (type) {
      this[type] = this[type] === 'password' ? 'text' : 'password'
    },
    submit () {
      this.loading = true
      let params = _.pickBy(this.params, _.identity)
      this.$http.put('/client_auth', params, {
        headers: this.clientAuth
      }).then(resp => {
        this.loading = false
        this.$store.commit('SET_CURRENT_CLIENT', resp.data.data)
        this.$router.push({ name: 'clientDashboard' })
      }).catch(err => {
        this.loading = false
        this.errors = {}
        if (err.response.status === 422) {
          let e = err.response.data.errors
          this.errors = _.reduce(e, (result, value, key) => {
            result[key] = value[0]
            return result
          }, {})
        }
      })
    }
  }
}
</script>
